<template>
	<div>
		<AsiCard :title="$t('paymentType.singular')" unwrapped no-bottom-margin class="overflow-hidden">
			<v-card-text class="pa-0">
				<AsiRadioGroup v-model="paymentTypeId" :disabled="loadingInternal" class="ma-0 pa-0">
					<v-list class="pa-0">
						<v-list-item v-for="paymentType in paymentTypes" :key="paymentType.id" @click="paymentTypeId = paymentType.id">
							<v-list-item-action>
								<v-radio :value="paymentType.id"/>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>
									{{ paymentTypeName(paymentType) }}
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</AsiRadioGroup>
			</v-card-text>
		</AsiCard>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import {Component, Emit, Prop, Watch} from 'vue-property-decorator';
	import AsiRadioGroup from "@/components/common/AsiRadioGroup";
	import {ICartShopListEntry} from "@/models/cart/CartShopModels";
	import {IPaymentTypeShopListEntry} from "@/models/payment-type/PaymentTypeShopModels";
	import Snackbar from "@/helpers/Snackbar";
	import TranslatedValueHelper from "@/models/translated-value/TranslatedValueHelper";
	import AsiCard from "@/components/common/AsiCard.vue";

	@Component({
		components: {AsiCard, AsiRadioGroup}
	})
	export default class CheckoutWizardStepPayment extends Vue {

		@Prop({type: Object, required: true})
		public cart!: ICartShopListEntry;

		@Prop({type: Boolean, default: false})
		public loading!: boolean;

		private loadingInternal: boolean = false;
		private paymentTypes: IPaymentTypeShopListEntry[] = [];

		public created(): void {
			this.loadPaymentTypes();
		}

		private get paymentTypeId(): string | null {
			return this.cart?.paymentType?.id ?? null;
		}

		private set paymentTypeId(id: string | null) {
			this.loadingInternal = true;
			this.$store.dispatch('cart/updatePaymentType', {cartId: this.cart.id, paymentTypeId: id})
				.catch(() => Snackbar.updateError())
				.finally(() => this.loadingInternal = false);
		}

		@Watch('loading', {immediate: true})
		private onLoadingChanged(value: boolean): void {
			this.loadingInternal = value;
		}

		@Watch('loadingInternal')
		@Emit('loadingChanged')
		private onLoadingInternalChanged(value: boolean): boolean {
			if (this.loading !== value) this.$emit('update:loading', value);
			return value;
		}

		private paymentTypeName(paymentType: IPaymentTypeShopListEntry): string | null {
			return TranslatedValueHelper.get(paymentType.name, this.$i18n.locale);
		}

		private loadPaymentTypes(): void {
			this.loadingInternal = true;
			this.$paymentTypeServiceShop.paymentTypes(null, null)
				.then(data => this.paymentTypes = data.data)
				.catch(() => Snackbar.loadingError())
				.finally(() => this.loadingInternal = false);
		}



	}
</script>

<style lang="scss" scoped>

</style>
